import { render } from "./indexGeneral.vue?vue&type=template&id=92f6777e"
import script from "./indexGeneral.vue?vue&type=script&lang=js"
export * from "./indexGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__